<template>
    <!--课程购买-->
    <div>
        <headers></headers>
        <div class="divider">
            <div class="auto">
                <a href="">首页 > 认证考试 > 考试报名 > 缴费</a>
            </div>
        </div>
        <div class="clearfix auto padding250">
            <div class="left">
                <p class="buy">报考科目：{{resdata.examName}}</p>
                <ul class="cless">
                    <li v-for="item in resdata.seasonList"><span>{{item.childexamName}}：
                        </span>{{item.examTime}} {{item.examStartTime}} - {{item.examEndTime}}
                    </li>
                    <li v-if="resdata.exanMode == 1"><span>考试方式：</span>网络考试</li>
                    <li v-else><span>考试方式：</span>线下考试</li>
                    <li><span>考试费用：</span>￥{{resdata.amount}}</li>
                </ul>

                <ul class="offer_money">
                    <li>需支付金额</li>
                    <li>应付金额：<span>￥{{resdata.amount}}</span></li>
                </ul>
            </div>
            <div class="left">
                <p class="titles">支付方式</p>
                <ul class="way">
                    <li :class="{active:0===nowIndex}" @click="toggle(0)">
                        <img src="./../../assets/radio3.png" alt="" v-if="nowIndex == 0">
                        <img src="./../../assets/radio1.png" alt="" v-else>
                        <label><img src="./../../assets/buy1.png" alt="" width="20">支付宝支付</label>
                    </li>
                    <li @click="toggle(1)" :class="{active:1===nowIndex}">
                        <img src="./../../assets/radio3.png" alt="" v-if="nowIndex == 1">
                        <img src="./../../assets/radio1.png" alt="" v-else>
                        <label><img src="./../../assets/buy2.png" alt="" width="21">微信支付</label>
                    </li>
                    <li @click="toggle(2)" :class="{active:2===nowIndex}">
                        <img src="./../../assets/radio3.png" alt="" v-if="nowIndex == 2">
                        <img src="./../../assets/radio1.png" alt="" v-else>
                        <label><img src="./../../assets/xuexibi.png" alt="" width="21">学习币支付</label>
                    </li>
                    <!--<li>
                        <Button class="offer">立即充值</Button>
                    </li>-->
                </ul>
                <div style="margin-bottom: 10px;">
                    <span style="font-size: initial;">可用学习币{{userAmount}}</span>
                    <router-link to="/ziliao/chongzhi" style="font-size: initial;">去充值学习币></router-link>
                </div>
                <div>
                    <Checkbox v-model="agree"> 同意</Checkbox>
                    <router-link :to="{name:'xieyicommon',query:{typeCode:'kssz', backUrl: 'buyExam'}}" class="desc">《考试须知》</router-link>
                </div>
                <a href="javascript:;">
                    <Button class="offer_btn" v-on:click="buyOrder()">立即支付</Button>
                </a>
            </div>
        </div>
        <Modal class-name="vertical-center-modal" v-model="isShow" footer-hide width="300px" @on-cancel="modalChange">
            <ul class="model_content">
                <li v-if="nowIndex === 0">支付宝扫码支付</li>
                <li v-if="nowIndex === 1">微信扫码支付</li>
                <li><img :src="payUrl" alt="" width="251"></li>
                <li>支付成功后，系统将自动为您开通相应服务</li>
            </ul>
        </Modal>
        <footers></footers>
    </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

    .agree .ivu-checkbox-wrapper {
        color: #666;
        /*font-size: 16px;*/
        font-size: 14px;
        margin-top: 15px;

        a {
            color: #083C68;
        }
    }

    .divider {
        height: 60px;
        background-color: #2F261E;
        font-size: 16px;
        line-height: 60px;
        text-align: left;
        color: #fff;

        span {
            margin: 0 10px;
        }

        a {
            color: #fff;

            &:hover {
                color: #9C7649;
                font-weight: 700;
            }
        }
    }

    .auto .left {
        background-color: #fff;
        margin-bottom: 20px;
        margin-top: 30px;
        padding: 30px;
        text-align: left;

        .buy {
            font-size: 20px;
            color: #333;
            padding-bottom: 20px;
        }

        .titles {
            font-size: 18px;
            color: #333;
            padding-bottom: 20px;
            border-bottom: 1px solid #dbdbdb;
        }

        ul.cless {
            border-bottom: 1px solid #dbdbdb;
            padding-bottom: 20px;

            li {
                font-size: 16px;
                color: #999;
                line-height: 30px;

                span {
                    color: #333;
                }
            }

        }

        .clearfix {

            padding-bottom: 40px;
            padding-top: 20px;
        }

        .offer_money {
            font-size: 16px;
            color: #333;
            padding-top: 20px;

            li:last-child {
                color: #999;
                margin-top: 10px;

                span {
                    font-size: 18px;
                    color: #ff0000;
                }
            }
        }

        .way {
            padding-top: 30px;

            li {
                display: inline-block;
                margin: 0 40px 40px 0;

                > img {
                    vertical-align: middle;
                    margin-right: 20px;
                }
            }

            li:last-child {
                button {
                    font-size: 14px;
                    color: #B2936B;
                    border: 1px solid #B2936B;
                    margin-bottom: 5px;
                }
            }

            li label {
                width: 154px;
                height: 48px;
                line-height: 48px;
                font-size: 16px;
                color: #333;
                border: 1px solid #d9d9d9;
                text-align: center;
                display: inline-block;
                cursor: pointer;

                img {
                    vertical-align: sub;
                    margin-right: 10px;
                }
            }

            li.active label {
                border-color: #00aaf0;
            }
        }

        .desc {
            color: #8C663E;
            font-size: 14px;
        }

        .offer_btn {
            color: #fff;
            font-size: 16px;
            background-color: #957960;
            height: 53px;
            width: 227px;
            border-color: #957960;
            margin-top: 20px;
        }
    }
</style>
<script type="text/ecmascript-6">
    import {orderbuyPageWeb, payorderStatusWeb, balancePayWeb } from "../../http"
    import headers from '../template/header'
    import footers from '../template/footer'

    export default {
        name: 'buy',
        props: {},
        data() {
            return {
                isShow:false,            //支付确认
                userAmount: 0,
                resdata: JSON.parse(this.$route.query.resdata),
                agree: false,
                doller: false,
                nowIndex: 0,
                ishsow: false,
                payUrl: '',
                timer: '',
            };
        },
        methods: {
            //微信支付窗口发生变化,清除定时器
            modalChange(){
                clearInterval(this.timer);
            },
            payInfo() {
                orderbuyPageWeb({orderId: this.resdata.orderId}).then(res => {
                    this.userAmount = res.data.userAmount;
                })
            },
            buyOrder() {
                if (!this.agree) {
                    this.$Notice.warning({
                        title: "考试缴费提醒",
                        desc: "请勾选考试须知",
                        duration: 3,
                    });
                    return
                }
                if (this.nowIndex == 2 && (this.resdata.amount * 1 > this.userAmount * 1)) {
                    this.$Notice.warning({
                        title: "考试缴费提醒",
                        desc: "学习币不足，请充值",
                        duration: 3,
                    });
                    return
                }
                //查询订单状态
                payorderStatusWeb({orderId: this.resdata.orderId}).then(res => {
                    if (res.data.orderStatus.code === 'OS_UNPAID') {
                        this.payOrder()
                    }else{
                        this.$Notice.warning({
                            title: '支付失败',
                            desc: '当前订单不可支付',
                            duration: 3,
                        });
                    }
                })
            },
            //支付二维码生成链接
            payCode() {
                let formalUrl = "http://api.cbstudy.com"
                let testUrl = "http://test.cbstudy.com"
                let localhost = "http://localhost:81"
                if (this.nowIndex == 0) {
                    // 跳转支付宝网页支付
                    var tempWindow = window.open('', '_blank', ''); //打开一个新的空白窗口
                    tempWindow.location.href = testUrl + "/base/common/toPay?payCode=AliPay&transactionType=PAGE&orderId=" + this.resdata.orderId;  //对新打开的页面进行重定向
                }
                if (this.nowIndex == 1) {
                    this.payUrl = testUrl + '/base/common/toQrPay?transactionType=NATIVE&payCode=WxPay&orderId=' + this.resdata.orderId;
                    this.isShow = true;
                }
            },
            payOrder(){
                if(this.nowIndex == 2) {     //使用学习币支付
                    balancePayWeb({orderId: this.resdata.orderId}).then(res => {
                        console.info(res)
                        if (res.code === 200) {
                            this.$router.push({name: 'success', query: {orderId: this.resdata.orderId, type: 1}})
                        } else {
                            this.$Modal.error({
                                title: '支付结果',
                                content: '支付失败!'
                            })
                        }
                    })
                }else{               //不使用学习币支付
                    this.payCode();
                    //二维码支付与监控
                    if(this.timer !== null){
                        clearInterval(this.timer)
                    }
                    this.timer = setInterval(() => {
                        this.newTimer = true;
                        //订单状态查询
                        payorderStatusWeb({orderId: this.resdata.orderId}).then(res => {
                            this.orderStatus = res.data.orderStatus.code;
                            //订单未支付
                            if (this.orderStatus === 'OS_UNPAID') {
                            }
                            //订单已完成
                            if (this.orderStatus === 'OS_FINISH') {
                                // this.status = 2;
                                clearInterval(this.timer);
                                this.$router.push({name: 'success', query: {orderId: this.resdata.orderId}})
                            }
                            //订单已关闭
                            if (this.orderStatus === 'OS_CLOSE') {
                                clearInterval(this.timer);
                                this.$Notice.warning({
                                    title: "支付失败",
                                    desc: "订单超时，已关闭",
                                    duration: 3,
                                });
                                this.isShow = false;
                            }
                        }).catch()
                    }, 3000)
                }
            },
            toggle(index) {
                this.nowIndex = index;
            },
        },
        created() {
            this.payInfo()
        },
        //退出页面清除定时器
        destroyed(){
            clearInterval(this.timer);
        },
        components: {
            headers,
            footers
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/examination/buy.vue